/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Search_IntroInputs */

const en_pc_tut_search_intro = /** @type {(inputs: Pc_Tut_Search_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search is find-as-you-type: results appear while you are still typing.`)
};

const zh_pc_tut_search_intro = /** @type {(inputs: Pc_Tut_Search_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索是边输入边查找的：还没打完字，结果就出来了。`)
};

/**
* | output |
* | --- |
* | "Search is find-as-you-type: results appear while you are still typing." |
*
* @param {Pc_Tut_Search_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_search_intro = /** @type {((inputs?: Pc_Tut_Search_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Search_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_search_intro(inputs)
	return zh_pc_tut_search_intro(inputs)
});
export { pc_tut_search_intro as "pc.tut.search.intro" }